import React from 'react';

/**
 * Family History section. Placeholder until the client sends the content
 * that belongs here.
 */
const FamilyHistory = () => {
  return (
    <div className="family-tree-container family-history">
      <div className="family-history-content">
        <h2 className="family-history-title">Family History</h2>
        <p className="family-history-empty">Content for this section is coming soon.</p>
      </div>
    </div>
  );
};

export default FamilyHistory;
